export default __webpack_public_path__ + "static/media/5_infor.d940d1dc.svg";